export const debounce = (fn: Function, timedelay: number) => {
  let timerid: any = null;
  return function () {
    clearTimeout(timerid);
    timerid = setTimeout(
      // @ts-ignore
      fn.bind(this, ...(arguments as any)),
      timedelay,
    );
  };
};

export const throttle = (fn: Function, timedelay: number) => {
  let ref = { pass: true, arguments: [] };
  return function () {
    // @ts-ignore
    ref.arguments = arguments;
    if (ref.pass) {
      setTimeout(() => {
        // @ts-ignore
        fn.apply(this, ref.arguments);
        ref.pass = true;
      }, timedelay);

      ref.pass = false;
    }
  };
};
